/* Tradeline quick view: "Choose options" on product cards opens a dialog with the product's
 * option pickers and add to cart, loaded from /products/<handle>?view=quick-view
 * (templates/product.quick-view.liquid). Uses the native <dialog> element for focus
 * handling and Escape. Depends on window.Tradeline (tl-theme.js). No external libraries.
 */
(() => {
  if (window.TradelineQuickView) return;
  window.TradelineQuickView = true;
  const T = window.Tradeline || (window.Tradeline = {});

  let dialog;
  const getDialog = () => {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'tl-qv-dialog';
    dialog.setAttribute('aria-labelledby', 'QuickViewTitle');
    dialog.innerHTML = `<button type="button" class="tl-icon-btn tl-qv-dialog__close" data-qv-close aria-label="${(T.strings && T.strings.close) || 'Close'}"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div class="tl-qv-dialog__body" data-qv-body></div>`;
    document.body.appendChild(dialog);
    dialog.addEventListener('click', (e) => { if (e.target === dialog || e.target.closest('[data-qv-close]')) dialog.close(); });
    dialog.addEventListener('close', () => {
      dialog.querySelector('[data-qv-body]').innerHTML = '';
      if (dialog._opener && document.contains(dialog._opener)) dialog._opener.focus();
    });
    return dialog;
  };

  const open = async (url, opener) => {
    opener.classList.add('is-loading');
    try {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('view', 'quick-view');
      const res = await fetch(u.toString());
      if (!res.ok) throw new Error(String(res.status));
      const html = await res.text();
      const d = getDialog();
      d.querySelector('[data-qv-body]').innerHTML = html;
      const title = d.querySelector('.tl-qv__title');
      if (title) title.id = 'QuickViewTitle';
      d._opener = opener;
      d.showModal();
    } catch (err) {
      window.location.href = url; // fall back to the product page
    } finally {
      opener.classList.remove('is-loading');
    }
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-view]');
    if (!btn || typeof HTMLDialogElement === 'undefined') return;
    e.preventDefault();
    open(btn.getAttribute('href') || btn.dataset.quickView, btn);
  });

  class TlQuickViewProduct extends HTMLElement {
    connectedCallback() {
      try { this.variants = JSON.parse(this.querySelector('[data-qv-variants]').textContent); } catch (err) { this.variants = []; }
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-qv-id]');
      this.atc = this.querySelector('[data-qv-atc]');
      this.addEventListener('change', (e) => { if (e.target.matches('[data-qv-option]')) this.update(); });
      if (this.form) this.form.addEventListener('submit', (e) => this.submit(e));
    }

    current() {
      const picked = Array.from(this.querySelectorAll('[data-qv-option]')).map((s) => s.value);
      return this.variants.find((v) => v.options.every((o, i) => o === picked[i]));
    }

    update() {
      const v = this.current();
      const now = this.querySelector('[data-qv-now]');
      const was = this.querySelector('[data-qv-was]');
      const qty = this.querySelector('[data-qv-qty]');
      if (!v) {
        this.atc.disabled = true;
        this.atc.textContent = this.atc.dataset.labelUnavailable;
        return;
      }
      this.idInput.value = v.id;
      if (now && T.formatMoney) now.textContent = T.formatMoney(v.price);
      if (was) { was.hidden = !(v.compare > v.price); if (T.formatMoney) was.textContent = T.formatMoney(v.compare); }
      if (qty) { qty.min = v.min; qty.step = v.step; if (Number(qty.value) < v.min) qty.value = v.min; }
      if (v.image) { const img = this.querySelector('[data-qv-image]'); if (img) { img.removeAttribute('srcset'); img.src = v.image; } }
      this.atc.disabled = !v.available;
      this.atc.textContent = v.available ? this.atc.dataset.labelAdd : this.atc.dataset.labelSold;
    }

    async submit(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const qty = Number((this.querySelector('[data-qv-qty]') || {}).value || 1);
      this.atc.classList.add('is-loading');
      try {
        const data = await T.cart.add([{ id: Number(this.idInput.value), quantity: qty }], 'quick-view');
        const opener = dialog && dialog._opener;
        if (dialog && dialog.open) dialog.close();
        T.afterAdd(data, opener);
      } catch (err) {
        if (T.toast) T.toast(err.message || (T.strings && T.strings.cartError) || '');
      } finally {
        this.atc.classList.remove('is-loading');
      }
    }
  }
  if (!customElements.get('tl-quick-view-product')) customElements.define('tl-quick-view-product', TlQuickViewProduct);
})();
